module.exports = __webpack_public_path__ + "img/abstract-shapes-9-1-01.6a4b6015.svg";